/* eslint-disable no-param-reassign */
import { toast } from 'react-toastify';

import axios, { AxiosError } from 'axios';

import history from '~/services/history';

interface ErrorResponse {
  message: string;
  code: string;
}

export const signOut = () => {
  clearLocalStorage();
  history.push('/');
};

export const clearLocalStorage = (): void => {
  const username = localStorage.getItem('@Afferolab:username');
  localStorage.clear();

  if (username) {
    localStorage.setItem('@Afferolab:username', username);
  }
};

const BASE_URL = process.env.REACT_APP_API_URL
  ? `${process.env.REACT_APP_API_URL}`
  : '/';

const api = axios.create({
  baseURL: `${BASE_URL}rest/wedo`,
});

api.interceptors.request.use(async (config) => {
  const token = localStorage.getItem('@Afferolab:token');
  const sessionid = localStorage.getItem('@Afferolab:sessionid');
  const orgKey = localStorage.getItem('@Afferolab:orgKey');
  const user = localStorage.getItem('@Afferolab:user');

  if (user) {
    const { orgId, personId } = JSON.parse(user);
    config.headers.orgId = `${orgId}`;
    config.headers.personId = `${personId}`;
  }

  if (token) {
    config.headers.Authorization = `${token}`;
  }

  if (sessionid) {
    config.headers.sessionid = sessionid;
  }

  if (orgKey) {
    config.headers.orgkey = orgKey;
  }

  return config;
});

api.interceptors.response.use(
  async (response) => Promise.resolve(response),
  async (error: AxiosError<ErrorResponse>) => {
    if (error.response) {
      const { status, data } = error.response;
      if (status === 401 && data.code === 'invalid_token') {
        toast.dismiss();
        signOut();
        toast.warn('Sessão expirada!');
      }
    }

    return Promise.reject(error);
  },
);
export default api;
